import React, { useState } from 'react'

import { greyMultibrandPalette } from '@masfront/common-b2c'

import { Typography, AccordionDetails, AccordionSummary, Accordion, Box } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

import useStyles from './SidebarStyles'

export interface SidebarAccordionProps {
  title?: string
  subtitle: string
  children: React.ReactNode
  reducedPadding?: boolean
  dataHook: string
}

function SidebarAccordion({
  title,
  subtitle,
  children,
  reducedPadding,
  dataHook,
}: SidebarAccordionProps) {
  const { accordion, summary } = useStyles()
  const [expanded, setExpanded] = useState(true)

  return title ? (
    <Box
      width="312px"
      data-hook={dataHook}
      px={reducedPadding ? 3 : 5}
      py={3}
      borderBottom={`1px solid ${greyMultibrandPalette[500]}`}
      boxShadow={`inset 0px -10px 20px -13px ${greyMultibrandPalette[900]}`}
    >
      <Box>
        <Accordion
          className={accordion}
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
        >
          <AccordionSummary
            className={summary}
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Box px={reducedPadding ? 2 : 0}>
              <Typography variant="h4">{title}</Typography>
              <Typography variant="body2" component={Box} mt={1}>
                {subtitle}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  ) : null
}

export default SidebarAccordion
